import "../static/css/bootsrap.min.css"
import "../static/css/font-awesome.min.css"
import "../static/css/hover-min.css"
import "../static/css/video-js.css"
import Vue from 'vue';
import App from './App.vue';
import store from './store/store';
import VueResource from 'vue-resource';
import { Vuelidate } from 'vuelidate'
import axios from 'axios';
import VueVideoPlayer from 'vue-video-player'
import JCanvas from 'jcanvas'
import $ from 'jquery'
import BootstrapVue from 'bootstrap-vue'
import Notifications from 'vue-notification'
import VTooltip from 'v-tooltip'
import IdleVue from 'idle-vue'
import VueProgressBar from 'vue-progressbar'
import VueTelInput from 'vue-tel-input'
import SocialSharing from 'vue-social-sharing'
import VueAnalytics from 'vue-analytics'
import router from './routes'
import './registerServiceWorker'
import VueI18n from 'vue-i18n'
import keys from "../static/translate.js";
import jqueryTouchswipe from "jquery-touchswipe";
import VueLazyload from 'vue-lazyload'
import Paginate from 'vuejs-paginate'
import '../static/jquery.dataTables.min'
import GAuth from 'vue-google-oauth2'
import VueGtm from 'vue-gtm'
const gauthOption = {
  clientId: '505551433601-qmceutdadebcesfkq1n7n4fdh0s9t1gc.apps.googleusercontent.com',
  scope: 'profile email',
  prompt: 'select_account'
}
Vue.use(VueGtm, {
    id: 'GTM-NKS8WB4', // Your GTM ID
    enabled: true, // defaults to true. Plugin can be disabled by setting this to false for Ex: during development
    debug: false, // Whether or not display console logs debugs (optional)
    vueRouter: router, // Pass the router instance to automatically sync with router (optional)
  });
let combined = "";
const eventsHub = new Vue()
axios.defaults.headers.post['Content-Type'] = 'application/json;charset=utf-8';
axios.defaults.headers.common['Accept'] = 'application/json';
JCanvas($, window);
Vue.use(VueVideoPlayer)
Vue.use(VueResource);
Vue.use(Vuelidate)
Vue.use(BootstrapVue);
Vue.use(Notifications);
Vue.use(VTooltip);
Vue.use(VueTelInput);
Vue.use(SocialSharing);
Vue.use(VueI18n);
Vue.use(jqueryTouchswipe);
Vue.use(VueLazyload);
Vue.use(GAuth, gauthOption)
Vue.use(VueAnalytics, {
    id: 'UA-131348218-1',
    router,
    autoTracking: {
        skipSamePath: true
      }
  })


Vue.use(IdleVue, {
    eventEmitter: eventsHub,
    idleTime: 20000
})
Vue.component('paginate', Paginate)

const options = {
    color: '#00c3e4',
    failedColor: '#00c3e4',
    thickness: '2px',
    transition: {
        speed: '1.5s',
        opacity: '0.6s',
        termination: 300
    },
    autoRevert: true,
    location: 'top',
    inverse: false
}
window.smoothyVersion = "v2.0.1",
    window.webVersion = "v2.0.1",

    Vue.use(VueProgressBar, options)
Vue.config.productionTip = false

export const eventBus = new Vue({
    methods: {
        ideBtnStatus(item) {
            this.$emit('ideBtnStatus', item);
        },
        stepBusFailed(item) {
            this.$emit('stepBusFailed', item);
        },
        ideHintBtn() {
            this.$emit('showHint');
        },
        decreaseNotificationsComment(){
            this.$emit('decreaseNotificationsComment');
        },
        // decreaseNotificationsCommunityComment(){
        //     this.$emit('decreaseNotificationsCommunityComment');
        // },
        openCode(item) {
            this.$emit('openCode', item);
        },
        setLessonId(item) {
            this.$emit('setLessonId', item);
        },
        setProjectGoal(item) {
            this.$emit('setProjectGoal', item);
        },
        setFouceIde() {
            this.$emit('setFouceIde');
        },
        showOverlay(isShow) {
            this.$emit('showOverlay', isShow);
        },
        showLookBetter(isShow) {
            this.$emit('showLookBetter', isShow);
        },
        getUpdatedStudents(students) {
            this.$emit('getUpdatedStudents', students);
        },
        showGameModal(){
            this.$emit('showGameModal');
        },
        fullScreen(){
            this.$emit('fullScreen');
        },
        fullScreenweb(){
            this.$emit('fullScreenweb');
        },
        fullScreensmoothy(){
            this.$emit('fullScreensmoothy');
        },
        fullScreenpython(){
            this.$emit('fullScreenpython');

        },
        setProjectId(item){
            this.$emit('setProjectId',item);
        },
        selectedProjectDetails(item){
            this.$emit('selectedProjectDetails',item)
        },
        forceRerender(){
            this.$emit('forceRerenders');
        },
        runCodeSmoothy() {
            this.$emit('runCodeSmoothy');
        },
        runCodePython(){
            this.$emit('runCodePython');

        },
         setProjectTitle(item) {
            this.$emit('setProjectTitle',item);
        },
        addProject() {
            this.$emit('addProject');
        },
        projectType() {
            this.$emit('projectType');
        },
        isStudentSubmited(item) {
            this.$emit('isStudentSubmited',item);
        },
        isCourseSubmited(item) {
            this.$emit('isCourseSubmited',item);
        },
        openCodepython(item) {
            this.$emit('openCodepython',item);
        },
    }
});

function changeLang(language) {
    if (store.getters.isAuth) {
        store.dispatch("changeLanguage", language).then(
            resp => {
            },
            error => {
                console.log(error);
            }
        );
    }

}
router.beforeEach((to, from, next) => {
    let language = to.query.lang;
    if (!language) {
        language = 'en';
        changeLang('en')
    }
    else if (language == 'en') {
        changeLang('en')
    }
    else if (language == 'ar') {
        changeLang('ar')
    } else {
        changeLang('en')
    }

    i18n.locale = language;
    next();
});

combined = keys;
const i18n = new VueI18n({
    locale: 'en',
    fallbackLocale: 'en',
    messages: combined.messages
});

Vue.component('v-style', {
    render: function (createElement) {
        return createElement('style', this.$slots.default)
    }
})

new Vue({
    el: '#app',
    router,
    store,
    i18n,
    render: h => h(App)
});


// WEBPACK FOOTER //
// ./src/main.js